import React from 'react';

const Newmexico = () => {
  return (
    <div>
      
    </div>
  );
}

export default Newmexico;
